import { getDocBucketAddress, getDocSignedAt, upsertDoc } from '@/core/data/dokumente'
import { setAufgabe } from '@/core/data/coachings'
import { createParticipantLink, type ParticipantLinkMinted } from '@/core/api/portal'

const BESCHEINIGUNG = 'bescheinigung'
const ANWESENHEITSLISTE = 'anwesenheitsliste'

export async function getZertifikatPath(coachingId: string): Promise<string | null> {
  return getDocBucketAddress(coachingId, BESCHEINIGUNG)
}

export async function sendZertifikat(coachingId: string): Promise<ParticipantLinkMinted> {
  await upsertDoc(coachingId, ANWESENHEITSLISTE, { teilnehmerSichtbar: true })
  await upsertDoc(coachingId, BESCHEINIGUNG, { teilnehmerSichtbar: true })
  const link = await createParticipantLink(coachingId, 'anwesenheitsliste')
  const teilnehmendenlisteSignedAt = await getDocSignedAt(coachingId, ANWESENHEITSLISTE)
  await setAufgabe(coachingId, teilnehmendenlisteSignedAt ? 'abgeschlossen' : 'teilnehmendenlisteUnterschrift')
  return link
}
